import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 41px);
  position: relative;
`

export const PageHeader = styled.div`
  margin: 16px 0;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
`

export const PageButtons = styled.div`
  display: inline-flex;
  align-items: center;
  margin-right: 22px;
  button {
    margin-right: 12px;
  }
`

export const Title = styled.span`
  font-weight: 300;
  font-size: 18px;
`

export const TableWrapper = styled.div`
  padding: 0 20px;
  flex: 1;
  justify-content: space-evenly;
  display: flex;
  flex-direction: column;
`
